import { z } from 'zod';
import { ENROLLMENT_MODES, GROUP_ROLES } from '../enums';
import { zId, zIso, zOptId, zOptText, zText } from './common';

export const groupTypeSchema = z.object({
  name: zText(80),
  description: zOptText(1000),
  isPublicDirectory: z.boolean().default(true),
  sortOrder: z.number().int().min(0).max(999).default(0),
});

export const groupSchema = z.object({
  groupTypeId: zId,
  campusId: zOptId,
  name: zText(120),
  description: zOptText(4000),
  locationName: zOptText(200),
  meetsSchedule: zOptText(120),
  isPublic: z.boolean().default(true),
  enrollment: z.enum(ENROLLMENT_MODES).default('request'),
  capacity: z.number().int().min(1).max(10000).nullable().optional(),
});
export const groupUpdateSchema = groupSchema.partial().extend({ archived: z.boolean().optional() });

export const membershipSchema = z.object({ personId: zId, role: z.enum(GROUP_ROLES).default('member') });
export const membershipUpdateSchema = z.object({ role: z.enum(GROUP_ROLES) });

export const enrollmentRequestSchema = z.object({ message: zOptText(1000) });
export const enrollmentDecisionSchema = z.object({ status: z.enum(['approved', 'declined']) });

export const groupEventSchema = z
  .object({
    name: zText(120),
    startsAt: zIso,
    endsAt: zIso,
    location: zOptText(200),
    description: zOptText(2000),
  })
  .refine((e) => new Date(e.endsAt) > new Date(e.startsAt), {
    message: 'El fin debe ser posterior al inicio',
    path: ['endsAt'],
  });

export const attendanceSchema = z.object({
  entries: z.array(z.object({ personId: zId, attended: z.boolean() })).max(1000),
});

export const groupResourceSchema = z
  .object({
    groupTypeId: zOptId,
    groupId: zOptId,
    name: zText(120),
    url: z.string().url().max(2000).nullable().optional(),
    description: zOptText(1000),
  })
  .refine((r) => r.groupTypeId || r.groupId, { message: 'Asigna a un tipo de grupo o grupo', path: ['groupId'] });
